import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, Row, Result } from 'antd'
import { useNavigate, useParams } from 'react-router-dom';
import { t } from 'i18next'
import { ArrowLeftOutlined, DeleteFilled, PlusOutlined } from '@ant-design/icons';
import { InputText } from 'common/elements';
import { Util } from 'common/util';
import { insertSalaryScale, getSalaryScaleByYear } from 'services/salary_scale_record';
import { SelectInput } from 'common/elements';
import dataSourceYear from "./SelectYear"


export default function FormCreate() {
   const [loadingBtn, setLoadingBtn] = useState(false);
   const [datas, setDatas] = useState({
      minColumns: [],
      midColumns: [],
      maxColumns: [],
   });
   const [salaryScales, setSalaryScales] = useState([])
   const [hasId, setHasId] = useState(false);
   const { year } = useParams();
   const navigate = useNavigate();

   useEffect(() => {

      getSalaryScaleByYear(year).then((response) => {
         const data = response.data.data;
         if (data) {
            setDatas(data)
            setSalaryScales(data.salaryScales.map((salaryScale) => ({
               id: salaryScale.id,
               level: salaryScale.level,
               jobTitles: salaryScale.jobTitles,
               grade: salaryScale.grade,
               minPayload: JSON.parse(salaryScale.minPayload),
               midPayload: JSON.parse(salaryScale.midPayload),
               maxPayload: JSON.parse(salaryScale.maxPayload),
               order: salaryScale.order,
            })))
            const foundId = data.salaryScales.find(obj => obj.id)
            setHasId(foundId ? true : false);
            if (data.salaryScales.length > 0) Util.getInstance().sweetAlertMessage(t("This Year has salary scale record exist!"), "warning");
         }
      })
      // eslint-disable-next-line
   }, []);

   const onFinish = () => {
      if (salaryScales.length === 0) {
         Util.getInstance().sweetAlertMessage(t("Please enter data at lest one"), "warning");
      } else {
         salaryScales.forEach((_, index) => delete salaryScales[index]["key"])
         const values = {
            year: datas.year,
            salaryScales: salaryScales
         }
         setLoadingBtn(true);
         insertSalaryScale(values).then(() => {
            onBack()
         }).finally(() => setLoadingBtn(false));
      }
   }

   const onChange = (key, index, value) => {
      salaryScales[index][key] = value;
   }

   const onChangesalaryScale = (key, subKey, index, subIndex, value) => {
      salaryScales[index][key][subIndex][subKey] = value;
   }

   const onNew = () => {
      const property = {
         key: Date.now() + Math.random(),
         level: null,
         jobTitles: null,
         grade: null,
         minPayload: datas.minColumns.map((_, index) => ({ [index + 1]: null })),
         midPayload: datas.midColumns.map((_, index) => ({ [index + 1]: null })),
         maxPayload: datas.maxColumns.map((_, index) => ({ [index + 1]: null })),
         order: null
      }
      salaryScales.push(property);
      setSalaryScales([...salaryScales])
   }

   const onDelete = (index) => {
      salaryScales.splice(index, 1)
      setSalaryScales([...salaryScales])
   }

   const onBack = () => {
      navigate("/salary-scale-record");
   }

   return (
      <>
         {
            Util.getInstance().hasPermission("view", "salary_scale_record") ?
               <Form onFinish={onFinish}>
                  <Row >
                     <div style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "15px 15px 0px 15px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                           <Button onClick={onBack} >
                              <ArrowLeftOutlined />
                              {t("text_back")}
                           </Button>
                           <span style={{ fontSize: 16, fontWeight: 600, marginLeft: 8 }}>
                              New Salary Scale Record
                           </span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                           <SelectInput
                              style={{ margin: 0, width: 100 }}
                              disabled
                              defaultValue={year}
                              placeholder={"Select year"}
                              valueKey="id"
                              dataSource={dataSourceYear}
                           />
                           {hasId ? null : <Button type="primary" loading={loadingBtn} htmlType="submit" style={{ minWidth: "93px", marginLeft: 8 }}>{t("text_save")}</Button>}
                        </div>
                     </div>
                  </Row>
                  <Row style={{ marginTop: 15 }}>
                     <Col span={24}>
                        <div style={{ padding: "0 15px", overflow: "auto", height: "83vh" }} >
                           <table id="salary-scale">
                              <thead style={{
                                 position: "sticky",
                                 top: -1,
                                 zIndex: 1
                              }}>
                                 <tr>
                                    <th rowSpan={2} style={{ background: "rgb(146, 208, 80)", width: 150 }}>Levels</th>
                                    <th rowSpan={2} style={{ background: "rgb(146, 208, 80)" }}>JOB TITLE</th>
                                    <th rowSpan={2} style={{ width: 60, background: "rgb(255, 255, 0)" }}>Grade</th>
                                    <th colSpan={datas.minColumns.length} style={{ background: "rgb(255, 255, 0)" }}>Min</th>
                                    <th colSpan={datas.midColumns.length} style={{ background: "rgb(255, 255, 0)" }}>Mid</th>
                                    <th colSpan={datas.maxColumns.length} style={{ background: "rgb(255, 255, 0)" }}>Max</th>
                                    <th rowSpan={2} style={{ width: 50 }}>Order</th>
                                    <th rowSpan={2} style={{ width: 90 }}>Action</th>
                                 </tr>

                                 <tr>
                                    {
                                       datas.minColumns.map((_, index) => <th key={`minColumns${index}`} style={{ width: 60, background: "rgb(255, 255, 0)" }}>{index + 1}</th>)
                                    }
                                    {
                                       datas.midColumns.map((_, index) => <th key={`midColumns${index}`} style={{ width: 60, background: "rgb(255, 255, 0)" }}>{datas.minColumns.length + (index + 1)}</th>)
                                    }
                                    {
                                       datas.maxColumns.map((_, index) => <th key={`maxColumns${index}`} style={{ width: 60, background: "rgb(255, 255, 0)" }}>{(datas.minColumns.length + datas.midColumns.length) + (index + 1)}</th>)
                                    }
                                 </tr>
                              </thead>
                              <tbody>
                                 {
                                    salaryScales.map((salaryScale, index) => {
                                       return <tr key={salaryScale.key ? salaryScale.key : salaryScale.id}>
                                          <td> <InputText disabled={hasId} defaultValue={salaryScale.level} onChange={(event) => onChange("level", index, event.target.value)} /></td>
                                          <td><Input.TextArea disabled={hasId} defaultValue={salaryScale.jobTitles} onChange={(event) => onChange("jobTitles", index, event.target.value)} /></td>
                                          <td> <InputText disabled={hasId} defaultValue={salaryScale.grade} onChange={(event) => onChange("grade", index, event.target.value)} /></td>
                                          {salaryScale.minPayload.map((minPay, indexMinPay) => {
                                             return <td key={`minPay${indexMinPay}`}>
                                                <InputText disabled={hasId} defaultValue={minPay[indexMinPay + 1]} onChange={(event) => onChangesalaryScale("minPayload", indexMinPay + 1, index, indexMinPay, event.target.value)} />
                                             </td>
                                          })}
                                          {salaryScale.midPayload.map((midPay, indexMidPay) => {
                                             return <td key={`midPayload${indexMidPay}`}>
                                                <InputText disabled={hasId} defaultValue={midPay[indexMidPay + 1]} onChange={(event) => onChangesalaryScale("midPayload", indexMidPay + 1, index, indexMidPay, event.target.value)} />
                                             </td>
                                          })}
                                          {salaryScale.maxPayload.map((maxPay, indexMaxPay) => {
                                             return <td key={`maxPay${indexMaxPay}`}>
                                                <InputText disabled={hasId} defaultValue={maxPay[indexMaxPay + 1]} onChange={(event) => onChangesalaryScale("maxPayload", indexMaxPay + 1, index, indexMaxPay, event.target.value)} />
                                             </td>
                                          })}
                                          <td>  <InputText disabled={hasId} defaultValue={salaryScale.order} onChange={(event) => onChange("order", index, event.target.value)} /></td>
                                          <td style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                             <div >
                                                <Button
                                                   danger
                                                   disabled={hasId}
                                                   title={t("text_delete")}
                                                   icon={<DeleteFilled style={{ color: "#fff" }} />}
                                                   shape="circle"
                                                   type="primary"
                                                   style={{
                                                      height: 35,
                                                      width: 35,
                                                      borderRadius: 35,
                                                      border: "none",
                                                      marginTop: 0,
                                                   }}
                                                   onClick={() => onDelete(index)}
                                                />

                                             </div>
                                          </td>
                                       </tr>
                                    })

                                 }
                              </tbody>
                              <tfoot>
                                 <tr>
                                    <td colSpan={(datas.minColumns.length + datas.midColumns.length + datas.maxColumns.length + 8)}>
                                       <Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={onNew} disabled={hasId}>
                                          {t("text_add_new")}
                                       </Button>
                                    </td>
                                 </tr>
                              </tfoot>
                           </table>
                        </div>
                     </Col>
                  </Row>
               </Form>
               :
               <Result
                  status="403"
                  title="403"
                  subTitle={t("text_sorry_you_are_not_authorized_to_access_this_page")}
               />
         }
      </>
   )
}
